import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import {environment as ENV} from '../../environments/environment';
/*
  Generated class for the ConfigProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export interface ApiConfig {
  baseUrl: string;
  loginUrl: string;
  route: string;
  training: string;
  sportevent: string;
  origin: string;
  spooortsWebApp:string;
  backoffice:string,
  event:string
}

@Injectable({providedIn:'root'})
export class ConfigProvider {
  testServer: boolean = false;

  testUrl = [
    "https://spooorts.de/"
  ];

  config: Promise<any>;
  active: string;
  constructor(private http: HttpClient, private storage: Storage) {
    this.config = new Promise((resolve, reject) => {
      this.getConfigFile().then(cfg => {
        resolve(cfg);
      });
    });
  }

  getConfigFile(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/data/config.json')
        .toPromise()
        .then((values: any) => {
          resolve(values);
        })
        .catch(error => {
          throw 'cannot get coutry.json';
        });
    });
  }

  public async urlConfig(): Promise<ApiConfig> {
    return {
      baseUrl: ENV.sporteventApi,  
      loginUrl: ENV.loginApi,
      training: ENV.trainingApi,
      route: ENV.routeApi,
      sportevent: ENV.sporteventApi,
      origin: ENV.spooortsWebApp,
      spooortsWebApp:ENV.spooortsWebApp,
      backoffice:ENV.backofficeApi,
      event:ENV.eventApi
    };
  }

  public defaultLanguage = 'de';
  public appId = 'com.spooorts.event';

  urlIndex = 0;
  private async getUrl() {
    let urls: string[] = (await this.config).url.domains;
    // let urls = this.testUrl;

    // let urls = this.testUrl;

    // if (!urls || urls.length === 0) {
    //   urls
    //   this.storage.set('urls', urls);

    // https://uknsowl.com/
    // }

    if (!urls) urls[0] = (this.testServer) ? "http://78.94.23.124/" : "https://spooorts.de/";

    urls[0] = (this.testServer)
      ? urls[0].replace("spooorts.ingenia-it.de", "78.94.23.124").replace("https", "http").replace("spooorts.de", "78.94.23.124").replace("spooorts.de", "78.94.23.124")
      : urls[0].replace("spooorts.ingenia-it.de", "spooorts.de").replace("http:", "https:");

    return urls[this.urlIndex % urls.length];
  }

  lastChange = 0;

  public changeUrl() {
    if (new Date().getTime() - this.lastChange > 1500) {
      this.urlIndex++;
    }
  }

  public switchToInitialUrl() {
    this.urlIndex = 0;
  }

  public testFailover() {

  }
  public getFirebaseConfig(){
    return {
      apiKey: "AIzaSyBbkZGm67zcz4QGxAW4_S7q-vZ53T5NlUw",
      authDomain: "",
      projectId:"spooorts-9dcf2",
      storageBucket:"spooorts-9dcf2.firebasestorage.app",
      messagingSenderId:"33955500516",
      appId:"1:33955500516:ios:0143b5d896cb9d617237f1",
      measurementId: "com.spooorts.eventsoriginal",
      vapidKey:"'BN7ydksrA3_Cah7n3HwHSP2-zYgzqTAUox2nRjcVuD9siSbjwo2WiqNcRj6rs89m5eg42_HkxxPA8PSgjkYzKLk"
    }
  }
}
